export default "__VITE_ASSET__DD92999q__"